var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main", style: { "--theme-color": _vm.themeColor } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileNavbarShow,
              expression: "mobileNavbarShow",
            },
          ],
          staticClass: "navbar",
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical",
              attrs: { "default-active": _vm.currRoute, mode: "vertical" },
            },
            _vm._l(_vm.navItemsMobile, function (item) {
              return _c(
                "el-menu-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.show,
                      expression: "item.show",
                    },
                  ],
                  key: item.index,
                  attrs: { index: item.index },
                  on: {
                    click: function ($event) {
                      return _vm.toRouter(item.route)
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(item.key ? _vm.$t(item.key) : item.text)),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("header", { staticClass: "header_pc" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.gameData.logoImage, alt: "" },
        }),
        _c(
          "div",
          { staticClass: "switch" },
          [
            _c(
              "el-menu",
              {
                staticClass: "el-menu-pc",
                attrs: {
                  "default-active": _vm.currRoute,
                  mode: "horizontal",
                  router: false,
                },
              },
              [
                _c(
                  "el-menu-item",
                  {
                    attrs: { index: "index" },
                    on: {
                      click: function ($event) {
                        return _vm.toRouter("/")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("top_up_center_text")) +
                        "\n\t\t\t\t"
                    ),
                  ]
                ),
                _vm._l(_vm.navItemsPc, function (item) {
                  return _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.show,
                          expression: "item.show",
                        },
                      ],
                      key: item.index,
                      attrs: { index: item.index },
                      on: {
                        click: function ($event) {
                          return _vm.toRouter(item.route)
                        },
                      },
                    },
                    [
                      item.icon
                        ? _c("img", {
                            staticStyle: {
                              width: ".375rem",
                              height: ".375rem",
                              "margin-right": ".2rem",
                            },
                            attrs: { src: item.icon, alt: "" },
                          })
                        : _vm._e(),
                      _c("span", [
                        _vm._v(_vm._s(item.key ? _vm.$t(item.key) : item.text)),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLogin,
                expression: "!hasLogin",
              },
            ],
            staticClass: "login bg_color",
            on: {
              click: function ($event) {
                return _vm.openLoginWindow()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("sign_in_text")))]
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLogin,
                expression: "hasLogin",
              },
            ],
            staticClass: "color login_out",
            on: {
              click: function ($event) {
                return _vm.loginOut()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("log_out_text")))]
        ),
      ]),
      _c("header", { staticClass: "header_m" }, [
        _c(
          "div",
          {
            on: {
              click: function ($event) {
                return _vm.openMobileNavbar()
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-server server",
              staticStyle: { color: "rgb(112, 112, 112)" },
            }),
          ]
        ),
        _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.gameData.logoImage, alt: "" },
        }),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLogin,
                expression: "!hasLogin",
              },
            ],
            staticClass: "login bg_color",
            on: {
              click: function ($event) {
                return _vm.openLoginWindow()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("sign_in_text")))]
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLogin,
                expression: "hasLogin",
              },
            ],
            staticClass: "color login_out",
            on: {
              click: function ($event) {
                return _vm.loginOut()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("log_out_text")))]
        ),
      ]),
      _c("LoginWindow"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }